import { forEach, isUndefined } from 'lodash-es';

import * as angular from 'angular';

class FilterOptionsMenuCtrl {
  filterOptions: any;
  filterUpdateCallback: any;

  // TODO: add filter active state to button menu
  constructor(private $element, private $scope) {
    'ngInject';

    angular.element($element).on('click', (e) => {
      if (
        $(this).closest('.open').is('.open') &&
        !isUndefined(e.stopPropagation)
      ) {
        e.stopPropagation();
      }
    });
  }

  selectAll() {
    // select all checkboxes
    forEach(this.filterOptions, (option: any) => {
      option.isSelected = true;
    });

    this.notifyOfSelections(this.filterOptions);
  }

  clearSelections() {
    // deselect all checkboxes
    forEach(this.filterOptions, (option: any) => {
      option.isSelected = false;
    });

    this.notifyOfSelections(this.filterOptions);
  }

  onItemToggle(item) {
    this.notifyOfSelections([item]);
  }

  notifyOfSelections(filterOptions) {
    // I think this was a slight misunderstanding on how variables are passed to functions when calling bound functions.
    this.filterUpdateCallback({
      $event: {
        data: filterOptions
      }
    });
  }
}

/**
 * There's no real docs for this one, so this will have to do for the moment.
 *
 * The "filterOptions" is an array of objects which look like this:
 * {name: "Medical staple or clip removers", itemsCount: 2, filterId: 27558, filterGroupId: "unspscs"}
 *
 * Note: If you provide a sortName on the objects then the menu items will be sorted by the sortName.
 *
 * Note: The itemsCount used to be required but I've removed that requirement because we don't always have it. If it's there it
 * will be displayed, if not, it will be skipped.
 *
 * Here's an example of it actually being used to display the available options for a given filter (in this case fomUnspscs
 * was an array of the above objects):
 *   <span data-test-selector="allocate-options">
 *     <button type="button" class="btn btn-default"
 *             bs-dropdown data-toggle="true" data-placement="bottom-left">UNSPSC
 *       <b class="apt-filter-icon" ng-class="{ 'fas': $ctrl.hasMembers($ctrl.unspscFilters) }"></b>
 *     </button>
 *     <div class="dropdown-menu">
 *       <filter-options-menu filter-options="$ctrl.fomUnspscs"
 *                            filter-update-callback="$ctrl.onFilterOptionsMenuChange($event)">
 *       </filter-options-menu>
 *     </div>
 *   </span>
 */
export const FilterOptionsMenuComponent = {
  bindings: {
    filterOptions: '<',
    filterUpdateCallback: '&',
    contentLabel: '@',
    isSingleColumn: '<',
  },
  controller: FilterOptionsMenuCtrl,
  // Seth wants this gone... we'll see if it stays gone
  // <div class="selectionOptions">
  //   <span class="clickable" ng-click="$ctrl.selectAll()">Select All</span>
  //   <span class="clickable" ng-click="$ctrl.clearSelections()">Clear</span>
  // </div>
  template: `
    <div>
      <div class="content-container">
        <div class="menu-content">
          <ul class="column-layout" ng-class="{'single-column': $ctrl.filterOptions.length < 6 || $ctrl.isSingleColumn}">
            <li ng-if="$ctrl.contentLabel" class="content-label">
              {{$ctrl.contentLabel}}
            </li>

            <li ng-repeat="option in $ctrl.filterOptions | orderBy : 'sortName' track by $index">
              <label>
                <input type="checkbox"
                       ng-change="$ctrl.onItemToggle(option)"
                       ng-model="option.isSelected"
                       ng-disabled="option.itemsCount !== undefined && !option.itemsCount"/>
                <span>{{option.name}}</span><span ng-if="option.itemsCount !== undefined">&nbsp;({{option.itemsCount}})</span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>`
};
